import { reactive } from 'vue';
import TimeService from '@/general/services/TimeService';
import { mergeInto } from '@/shared/utils';
import JobItemClient from '../client/JobItemClient';
import Job from '../models/Job';
import JobContext from '../models/JobContext';
import JobItem, { JobPartsData } from '../models/JobItem';

class JobItemService {
  async loadAll(context: JobContext): Promise<void> {
    context.items = await JobItemClient.loadAll(context.dossier.id);
    const referenceTime = TimeService.now.value.clone().subtract(1, 'minutes');
    context.items.forEach(item => item.isRecent = item.createdOn.isAfter(referenceTime));
  }

  async link(source: JobItem, target: Job | null, context: JobContext): Promise<void> {
    await JobItemClient.link(source.id, target?.id ?? null, context.dossier.id);
    context.items.forEach(item => {
      if (item.id === source.id) item.jobId = target?.id ?? null;
    });
  }

  async linkAllFromJob(source: Job, target: Job | null, keepSource: boolean, context: JobContext): Promise<void> {
    await JobItemClient.linkAllFromJob(source.id, target?.id ?? null, keepSource, context.dossier.id);
    context.items.forEach(item => {
      if (item.jobId === source.id) item.jobId = target?.id ?? null;
    });
  }

  async updatePartStatuses(data: JobPartsData, context: JobContext): Promise<void> {
    const changedItems = data.items.filter(itemData => context.getItemById(itemData.id)?.hasStatusChanges(itemData));
    await JobItemClient.updateStatus({ ...data, items: changedItems }, context.dossier.id);
    context.dossier.partsPickingLocation = data.location;
    changedItems.forEach(itemData => {
      const item = context.getItemById(itemData.id);
      if (item) {
        item.updateWith(itemData);
        if (context.selectedJob && context.selectedJob.id === item.jobId) mergeInto(item, context.selectedJob.items);
      }
    });
  }
}

export default reactive(new JobItemService());